import { MONEY_ARTICLE_DEFAULTS } from "./money-article-contract";

export const MONEY_ARTICLE_SERVICE_NODE = "moneyArticleService";
export const MONEY_ARTICLE_SERVICE_DEFAULTS = { ...MONEY_ARTICLE_DEFAULTS };
// The new presentation uses exactly the same persisted choices and validation.
export { normalizeMoneyArticleAttrs as normalizeMoneyArticleServiceAttrs } from "./money-article-contract";
